import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const slicers = createSlice({
    name : "collectionsView",
    initialState,
    reducers : {
        setCollections : (state, action) => {
            state.path = action.payload.path;
            state.backendId = action.payload.backendId;
        },
        setBackendId : (state, action) => {
            state.backendId = action.payload;
        },
        setCollectionId : (state, action) => {
            state.collectionId = action.payload;
        },
        setSelectedpath : (state, action) => {
            state.selectedpath = action.payload;
        },
        setIsFileView : (state, action) => {
            state.isFileView = action.payload;
        },
        setIsFolderView : (state, action) => {
            state.isFolderView = action.payload;
        }
    }
})


export const { setCollections, setBackendId, setCollectionId } = slicers.actions;
export default slicers.reducer;